import { CompanionError } from '../_internal/error/CompanionError';
import { getCachedSession } from '../session';
export function siteIdToToken(id, sites) {
    var _a;
    sites = sites !== null && sites !== void 0 ? sites : (_a = getCachedSession()) === null || _a === void 0 ? void 0 : _a.sites;
    const foundSite = sites === null || sites === void 0 ? void 0 : sites.find((site) => site.site_id === id);
    if (!foundSite) {
        throw new CompanionError({
            error: new Error(`Can not find site id ${id}`),
            code: 'SITE_ID_MISSING',
        });
    }
    return foundSite.token;
}
siteIdToToken.ERR = {
    SITE_ID_MISSING: 'SITE_ID_MISSING',
};
export function siteTokenToId(token, sites) {
    var _a;
    sites = sites !== null && sites !== void 0 ? sites : (_a = getCachedSession()) === null || _a === void 0 ? void 0 : _a.sites;
    const foundSite = sites === null || sites === void 0 ? void 0 : sites.find((site) => site.token === token);
    if (!foundSite) {
        throw new CompanionError({
            error: new Error(`Can not find site token ${token}`),
            code: 'SITE_TOKEN_MISSING',
        });
    }
    return foundSite.site_id;
}
siteTokenToId.ERR = {
    SITE_TOKEN_MISSING: 'SITE_TOKEN_MISSING',
};
export function findSite(idOrToken, sites) {
    var _a;
    sites = sites !== null && sites !== void 0 ? sites : (_a = getCachedSession()) === null || _a === void 0 ? void 0 : _a.sites;
    const id = idOrToken.includes('-') ? siteTokenToId(idOrToken, sites) : idOrToken;
    const foundSite = sites === null || sites === void 0 ? void 0 : sites.find((site) => site.site_id === id);
    if (!foundSite) {
        throw new CompanionError({
            error: new Error(`Can not find site id ${idOrToken}`),
            code: 'SITE_NOT_FOUND',
        });
    }
    return foundSite;
}
findSite.ERR = {
    SITE_NOT_FOUND: 'SITE_NOT_FOUND',
};
